export default {
  UPDATE_FILE_LIST: 'UPDATE_FILE_LIST',
  ADD_FILES_TO_UPLOAD: 'ADD_FILES_TO_UPLOAD',
  REMOVE_FILES_TO_UPLOAD: 'REMOVE_FILES_TO_UPLOAD',
  UPDATE_FILE_PARAMETER: 'UPDATE_FILE_PARAMETER',
  BULK_UPDATE_FILE_PARAMETER: 'BULK_UPDATE_FILE_PARAMETER',
  SET_FILE_IS_DELETING: 'SET_FILE_IS_DELETING',
};
